import React, { useState, useEffect, Fragment } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useHistory } from 'react-router-dom'

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

import classnames from 'classnames'
import { Link } from 'react-router-dom'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Link as MaterialLink } from '@material-ui/core'

import { withSnackbar } from 'notistack';

import FormGroup from '@material-ui/core/FormGroup'
import Checkbox from '@material-ui/core/Checkbox'

const styles = (theme) => ({
    error: {
        color: 'indianred'
    },
    link: {
        color: theme.palette.primary.main + ' !important',
        cursor: 'pointer'
    }
})
const useOptions = () => {
    const options = {
        style: {
            base: {
                fontFamily: 'Open Sans',
                fontSize: '16px',
                color: "#424770",
                letterSpacing: "0.025em",
                fontFamily: "Source Code Pro, monospace",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#9e2146"
            }
        }
    }

    return options;
};

const CardForm = ({ handleTokenCallback, cart, disabled, handleReserveCase, handleSelectedCardCase, classes, currentUser, cards, cardDefault, enqueueSnackbar }) => {
    console.log(currentUser)
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    const history = useHistory();
    const [email, setEmail] = useState(currentUser ? currentUser.email : '');
    const [clicked, setClicked] = useState(false);
    const [emailErr, setEmailErr] = useState(undefined);
    const [userWantsNewCard, setUserWantsNewCard] = useState(false);
    const [userSelectedCard, setUserSelectedCard] = useState(cardDefault);
    const [payTermsAndCond, setPayTermsAndCond] = useState(disabled)
    const [checkBoxPayTerms, setCheckBoxPayTerms] = useState(disabled)
    console.log(disabled);

    useEffect(() => {
        console.log(cart);
    }, [])

    useEffect(() => {
        console.log(userSelectedCard)
    }, [userSelectedCard])

    const validateEmail = (email) => {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regexp.test(email);
    }
    const emailChanged = (e) => {
        console.log(e.target.value)
        if (validateEmail(e.target.value)) {
            setEmailErr(false);
        } else {
            if (!emailErr)
                setEmailErr(true);
        }

        setEmail(e.target.value)


    }

    const handleRecurringPayTermsChange = (e) => {
        setCheckBoxPayTerms(e.target.checked)
    }


    const handleChange = (event) => {
        setUserSelectedCard(event.target.value);

    }
    const switchToAnotherCardOption = () => {
        setUserWantsNewCard(true)
    }
    const switchToPickCards = () => {
        setUserWantsNewCard(false)
    }

    const handleSubmit = async event => {
        event.preventDefault();


        // To prevent double clicks
        if (clicked) {
            return;
        }


        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }


        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);

        if (result.error) {
            // Show error to your customer.
            enqueueSnackbar(result.error.message, { variant: 'error', persist: 'false' });

            console.log(result.error.message);
        } else {
            // Send the token to your server.
            // This function does not exist yet; we will define it in the next step.
            //stripeTokenHandler(result.token);
            console.log("[Token]", result.token);
            setClicked(true);

            handleTokenCallback(result.token, (err) => {
                if (err) {
                    enqueueSnackbar(err, { variant: 'error', persist: 'true' });
                    setClicked(false);
                }

            });



        }


    };

    return (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">


            <Grid container spacing={3} alignItems="center">
                <Grid item xs><Paper style={{ padding: '12px' }}>  <CardElement
                    options={options}
                    onReady={() => {
                        console.log("CardElement [ready]");
                    }}
                    onChange={event => {
                        console.log("CardElement [change]", event);
                    }}
                    onBlur={() => {
                        console.log("CardElement [blur]");
                    }}
                    onFocus={() => {
                        console.log("CardElement [focus]");
                    }}
                /></Paper>
                </Grid>
            </Grid>


            <Grid container spacing={3} alignItems="center">
                {!payTermsAndCond && <Grid item >
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            value="end"
                            control={<Checkbox color="primary" value={checkBoxPayTerms} onChange={handleRecurringPayTermsChange} />}
                            label={<div>I agree to the recurring payment <MaterialLink target="_blank" href="https://register.tanglewoodresort.club/#/recurring-payment-terms">terms and conditions</MaterialLink>.</div>}
                            labelPlacement="end"
                        />
                    </FormGroup>
                </Grid>}
                <Grid container item xs justify="flex-end">

                    <Button type="submit" disabled={!stripe || clicked || !checkBoxPayTerms} variant="contained" size="large" name="MakePaymentBtn" color="primary" >
                        ADD CARD
                    </Button>
                </Grid>
            </Grid>

        </form>
    );
};

export default withStyles(styles)(withSnackbar(CardForm));
